import { includes } from 'lodash';

import { initialState } from './initialState';

export const SET_IS_MOBILE_NAV_OPEN = 'iron/ui/SET_IS_MOBILE_NAV_OPEN';
export const CLOSE_MOBILE_NAV = 'iron/ui/CLOSE_MOBILE_NAV';
export const TURN_ON_BANNER = 'iron/ui/TURN_ON_BANNER';
export const TURN_OFF_BANNER = 'iron/ui/TURN_OFF_BANNER';
export const SET_SHOW_WHERE_ARE_YOU_MODAL =
  'iron/ui/SET_SHOW_WHERE_ARE_YOU_MODAL';
export const SET_NAVBAR_HEIGHT = 'iron/ui/SET_NAVBAR_HEIGHT';

export const setIsMobileNavOpen = () => ({
  type: SET_IS_MOBILE_NAV_OPEN,
});

export const closeMobileNav = () => ({
  type: CLOSE_MOBILE_NAV,
});

const BANNER_NAMES = Object.keys(initialState.banners);

export const turnOnBanner = (payload: string) => {
  if (!includes(BANNER_NAMES, payload)) {
    throw new Error('Turn On Banner Must Match Banner Name');
  }

  return {
    type: TURN_ON_BANNER,
    payload,
  };
};

export const turnOffBanner = (payload: string) => {
  if (!includes(BANNER_NAMES, payload)) {
    throw new Error('Turn Off Banner Must Match Banner Name');
  }

  return {
    type: TURN_OFF_BANNER,
    payload,
  };
};

export const setShowWhereAreYouModal = (
  showWhereAreYouModal: boolean,
  dismissed = false,
  banner = false,
) => ({
  type: SET_SHOW_WHERE_ARE_YOU_MODAL,
  payload: {
    showWhereAreYouModal,
    dismissed,
    banner,
  },
});

export const setNavbarHeight = (height: number) => ({
  type: SET_NAVBAR_HEIGHT,
  payload: { height },
});
